<template>
    <header id="site-header__container" role="banner" :class="{solid: solid === '1' }">
        <div id="site-header" :class="{'navbar-hidden': !revealNavbar}">
            <div class="drop-shadow"></div>
            <b-navbar v-if="getNavigation" :class="{active: focusedNav}">
                <b-navbar-brand href="/" v-if="getSettings.LogoContrast && getSettings.LogoContrast.ID">
                    <b-img :src="getSettings.LogoContrast.URL"></b-img>
                </b-navbar-brand>
                <b-navbar-nav class="main-nav-wrapper" :class="{isOpen: isOpen}">
                    <div v-for="(nav, index) in getNavigation" :key="'menu-top' + index">
                        <b-nav-item-dropdown :ref="'nav'+index" v-if="nav.ChildItems && nav.ChildItems.length" :text="nav.Title"
                                             @shown="focusedNav = true"
                                             @hidden="focusedNav = false"
                                             @mouseenter.native="openMenu('nav'+index)" @toggle="gotoLink(nav.PageLink)">
                            <div class="mobile-nav" @click.stop="toggleBack(event)"><i class="fal fa-chevron-left"></i>{{ nav.Title }}</div>
                            <b-dropdown-group v-if="child.ChildItems" v-for="(child, index) in nav.ChildItems" :key="'menu-child' + index">
                                <b-nav-item v-if="child.PageLink" :href="child.PageLink">{{ child.Title }}</b-nav-item>
                                <b-dropdown-item v-if="grandChild.PageLink" v-for="(grandChild, index) in child.ChildItems"
                                                 :key="'menu-grandchild' + index"
                                                 :href="grandChild.PageLink">
                                    {{ grandChild.Title }}
                                </b-dropdown-item>
                            </b-dropdown-group>
                            <b-nav-item v-else-if="child.PageLink" :href="child.PageLink">{{ child.Title }}</b-nav-item>
                            <div class="nav-item cta-box" v-if="nav.ChildItems.length < 4 & nav.NavCTALink !== '' ">
                                <p>{{ nav.NavCTAContent }}</p>
                                <a :href="nav.NavCTALink" class="btn btn-light-skinny-outline">{{ nav.NavCTAText }}</a>
                            </div>
                        </b-nav-item-dropdown>
                        <b-nav-item v-else-if="nav.PageLink" :href="nav.PageLink">{{ nav.Title }}</b-nav-item>
                    </div>
                    <div v-if="getClubNav.length > 1">
                        <i class="fas fa-user-circle"></i>
                        <b-nav-item-dropdown text="Manage Account" class="user" :ref="'user-nav'" @shown="focusedNav = true"
                                             @hidden="focusedNav = false" @mouseenter.native="openMenu('user-nav')">
                            <div class="mobile-nav" @click.stop="toggleBack(event)"><i class="fal fa-chevron-left"></i>Back</div>
                            <b-nav-item v-if="nav.PageLink" v-for="(nav, index) in getClubNav" :key="'menu-side' + index" :href="nav.PageLink">
                                {{ nav.Title }}
                            </b-nav-item>
                        </b-nav-item-dropdown>
                    </div>
                    <div v-else>
                        <i class="fas fa-user-circle"></i>
                        <b-nav-item v-if="nav.PageLink" v-for="(nav, index) in getClubNav" :key="'menu-side' + index" :href="nav.PageLink"
                                    class="user">{{ nav.Title }}
                        </b-nav-item>
                    </div>
                    <div class="quick-links">
                        <button class="quick-link btn-light-skinny-outline"><a :href="`tel:${getSettings.ContactPhone}`">Call
                            {{ getSettings.ContactPhone }}</a></button>
                        <button class="quick-link btn-light-skinny-outline"><a target="_blank"
                                                                               :href="`https://maps.google.com/?daddr=${getSettings.GVLatitude},${getSettings.GVLongitude}`">GET
                            DIRECTIONS</a></button>
                    </div>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
<!--                    <b-nav-item class="cart" @click="toggleShowCart">
                        <span><i class="fal fa-shopping-cart"></i></span>
                        <span class="items-sum">{{ getItemSum }}</span>
                    </b-nav-item>-->
                    <b-nav-item class="search" :href="getSettings.SiteSearchPageLink"><span><i class="fal fa-search"></i></span></b-nav-item>
                    <b-nav-item class="mobile-nav-trigger" @click="isOpen = !isOpen" :class="{'menu-opened': isOpen}"
                                aria-label="mobile navigation trigger">
                        <i class="fas fa-bars"></i>
                        <i class="fal fa-times"></i>
                    </b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </div>
    </header>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'SiteHeader',
    props: {
        solid: {type: String}
    },
    data() {
        return {
            focusedNav: false,
            isOpen: false,
            revealNavbar: true,
            lastScrollPosition: 0,
            lastScrollTop: 0
        };
    },
    computed: {
        ...mapGetters(['getNavigation', 'getClubNav', 'getSettings', 'getItemSum'])
    },
    methods: {
        ...mapActions(['fetchNavigationItems', 'toggleShowCart', 'fetchOrder']),

        onScroll() {
            let currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPosition > this.lastScrollTop) { //scroll down
                $("#site-header").removeClass("nav-shrink");
                $("#site-header").css("position", "relative");
            } else {
                $("#site-header").addClass("nav-shrink");
                $("#site-header").css("position", "fixed");
            }
            // if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
            //     return
            // }
            //this.revealNavbar = currentScrollPosition < this.lastScrollPosition
            this.lastScrollTop = currentScrollPosition <= 0 ? 0 : currentScrollPosition; // For Mobile or negative scrolling
        },
        openMenu(ref) {
            if (window.innerWidth >= 1200) {
                let item = this.$refs[ref];
                if (Array.isArray(item)) {
                    item = this.$refs[ref][0];
                }

                item.show();

                let opened = $('.dropdown-menu.show');
                if (opened.length) {
                    opened.on('mouseleave', () => {
                        item.hide();
                    });
                }
            }


        },
        toggleBack(nav) {
            if ($(event.target).parents('.dropdown').hasClass('show')) {
                $(event.target).parents('.dropdown').removeClass('show');
                $(event.target).parents('.dropdown').find('.dropdown-menu').removeClass('show');
            } else {
                $(event.target).parents('.dropdown').addClass('show');
            }

        },
        gotoLink(link) {
            if (link && window.innerWidth >= 1200) {
                window.location.replace(link);
            }
        }
    },
    created() {
        this.fetchNavigationItems();
        this.fetchOrder();
    },
    mounted() {
        // this.$nextTick(function () {
        //     window.addEventListener("scroll", function () {
        //         var navbar = document.getElementById("site-header");
        //         var nav_classes = navbar.classList;
        //         if (document.documentElement.scrollTop >= 150) {
        //             if (nav_classes.contains("nav-shrink") === false) {
        //                 nav_classes.toggle("nav-shrink");
        //             }
        //         } else {
        //             if (nav_classes.contains("nav-shrink") === true) {
        //                 nav_classes.toggle("nav-shrink");
        //             }
        //         }
        //
        //     })
        // }),
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    watch: {
        isOpen() {
            document.body.style.overflow = this.isOpen ? 'hidden' : ''
        }
    }
};
</script>
